import React from 'react';
import { useNavigate } from 'react-router-dom';
import { SfcShellLeftNav } from '@waypoint/react-components/dist/sfc-components';
import { withSession } from '../session';
import useMenu from './menu';
import { clearClientOrgSettings, clearSiPartnerSettings, useApplicationState } from '../../utilities/applicationState';

function LeftNav({ session = {} }) {
	const navigate = useNavigate();
	const [{ appRoutes }] = useMenu();
	const [, dispatch] = useApplicationState();

	const clearAppSettings = (id) => {
		if (id === 'client-orgs-nav') {
			dispatch(clearClientOrgSettings());
		}
		if (id === 'si-partners-nav') {
			dispatch(clearSiPartnerSettings());
		}
	};

	const allRoutes = [...appRoutes];

	const filterRoutes = allRoutes
		.map((route) => {
			if (route.roles.find(role => session.roles.includes(role)) && route.hasOwnProperty("id")) {
				if (route.id === "partners-nav" && session.partners.length < 1 && !session.roles?.includes('euClientSelfServiceProjectUser')) {
					return;
				} else if (route.id === "partners-nav" && session.isCAOrg) {
					return;
				}
				return route;
			}
		})
		.filter((route) => route !== undefined);

	const activeItem = filterRoutes.find(({ active }) => active);

	return (
		<SfcShellLeftNav
			slot="nav"
			role="navigation"
			menuProvider={filterRoutes}
			activeItem={activeItem}
			onNavigate={(event) => {
				const { detail } = event;
				clearAppSettings(detail.id);
				navigate(detail.pathname);
				event.preventDefault();
			}}
		>
		</SfcShellLeftNav>
	);
}

export default withSession(LeftNav);
